export default {
  controls: [
    {
      title: 'special.controls.iBoard',
      icon: 'icon-iboard',
      controlPanel: 'iboard'
    }
  ]
}
